<template>
  <!-- 这是新增页面ABC车间 -->
  <div id="overviewcomp">
    <div id="right">
      <div id="switchingroom">
        <div class="right-title">
          <div id="siteswitch">
            <div id="head"><img :src="$store.state.homeitem.png" alt="" /></div>
            <div id="siteswitch-title">
              <h2 id="title-name">
                {{ $store.state.homeitem.man }}
              </h2>
              <!-- @areaId="childID"    -->
              <Switchsite @handlevalue="handleValue"></Switchsite>
            </div>
          </div>
          <el-button
            @click="toAll"
            @mouseenter="homeitemall"
            @mouseleave="homeitemall == 1"
          >
            <i class="el-icon-s-home"></i> 返回园区总览</el-button
          >
        </div>
        <div id="oC">
          <p>温度:{{ temperature }}℃</p>
          <div></div>
          <p>
            湿度:<span>{{ humidity }}%</span>
          </p>
        </div>
        <!-- subLoopUrl{{$store.getters.mqttVal("CX/ZTR14/P")}} -->
        <div id="electricquantity">
          <p class="record-item">进线断路器状态</p>
          <!-- <p class="record-op" v-if="isclick > 0">--</p> -->
          <p class="record-op">
             {{
                    voltageClasses1
                      ? voltageClasses1
                      : $store.state.homeitem.onestate1
                  }}
                  <span>/</span>
                  {{
                    voltageClasses2
                      ? voltageClasses2
                      : $store.state.homeitem.onestate2
                  }}
          </p>
        </div>

        <div id="list">
          <h3 id="title">运行状态</h3>
          <!-- <p>回路名称</p> -->
          <Overviewitemcomponents @compitem="compitem"></Overviewitemcomponents>
        </div>
        <div id="state">
          <div id="state-one" v-for="(all, index) in state" :key="index">
            <div id="activefactors" v-for="item in all" :key="item.id">
              <p class="record-item">{{ item.class }}</p>
              <b>
                <p
                  class="record-st"
                  v-if="item.backg"
                  :style="
                    'color:' +
                    ($store.getters.mqttVal(mqqttwo + item.data) <= 0.5
                      ? '#F5AA00'
                      : $store.getters.mqttVal(mqqttwo + item.data) <= 1
                      ? '#68D86A'
                      : '#fd4238')
                  "
                >
                  {{
                    $store.getters.mqttVal(mqqttwo + item.data)
                      ? $store.getters.mqttVal(mqqttwo + item.data)
                      : "--"
                  }}

                  <span v-if="item.backg">{{ item.backg }}</span>
                  <span v-else>{{ item.sign }}</span>
                </p>

                <p class="record-st" v-else>
                  {{
                    item.numtotal
                      ? $store.getters.mqttVal(mqqttwo + item.data)
                        ? $store.getters.mqttVal(mqqttwo + item.data) /
                          item.numtotal
                        : "- -"
                      : $store.getters.mqttVal(mqqttwo + item.data)
                      ? $store.getters.mqttVal(mqqttwo + item.data)
                      : item.nodata
                      ? item.nodata
                      : "- -"
                  }}
                  <!-- <span>{{item.nodata}}</span>  -->
                  <span v-if="item.backg">{{ item.backg }}</span>
                  <span v-else>{{ item.sign }}</span>
                </p>
              </b>
              <!-- <p>{{item.stor}}<span>{{item.sign}}</span></p> -->
            </div>
          </div>
        </div>
        <div id="temperature-all">
          <div class="temperature1">
            三相电流
            <div class="temperature-item1">
              <b>
                <div class="clay">
                  A:
                  
                  <h5>
                    {{
                      $store.getters.mqttVal(mqqttwo + "/Ia")
                        ? $store.getters.mqttVal(mqqttwo + "/Ia")
                        : "--"
                    }}

                   A
                  </h5>
                </div></b
              >
              <b>
                <div class="clay">
                  B:
                  
                  <h5>
                    {{
                      $store.getters.mqttVal(mqqttwo + "/Ib")
                        ? $store.getters.mqttVal(mqqttwo + "/Ib")
                        : "--"
                    }}
                  A
                  </h5>
                </div></b
              >
              <b>
                <div class="clay">
                  C:
                  
                  <h5>
                    {{
                      $store.getters.mqttVal(mqqttwo + "/Ic")
                        ? $store.getters.mqttVal(mqqttwo + "/Ic")
                        : "--"
                    }}
                 A
                  </h5>
                </div></b
              >
            </div>
          </div>
          <div class="temperature2">
            三相电压
            <div class="temperature-item2">
              <b>
                <div class="clay">
                  A:
                  
                   <!-- {{
                      $store.getters.mqttVal(mqqttwo + "/Ua")
                        ? $store.getters.mqttVal(mqqttwo + "/Ua")
                        : "--"
                    }} -->
                  <h5>
                   111
                  v
                  </h5>
                </div></b
              >
              <b
                ><div class="clay">
                  B:
                  
                  <h5>
                    {{
                      $store.getters.mqttVal(mqqttwo + "/Ub")
                        ? $store.getters.mqttVal(mqqttwo + "/Ub")
                        : "--"
                    }}
                  v
                  </h5>
                </div></b
              >
              <b>
                <div class="clay">
                  C:
                  
                  <h5>
                    {{
                      $store.getters.mqttVal(mqqttwo + "/Uc")
                        ? $store.getters.mqttVal(mqqttwo + "/Uc")
                        : "--"
                    }}
                    v
                  </h5>
                </div></b
              >
            </div>
          </div>
          <div class="temperature3">
            <!-- 母排温度(C): -->
            电缆温度
            <div class="temperature-item3">
              <b>
                <div class="clay">
                  <h5>
                    {{
                      $store.getters.mqttVal(mqqttwo + "/Temperature")
                        ? $store.getters.mqttVal(mqqttwo + "/Temperature")
                        : "--"
                    }}
                  </h5>
                  <p>
                    {{
                      $store.getters.mqttVal(mqqttwo + "/Temperature")
                        ? "℃"
                        : ""
                    }}
                  </p>
                </div></b
              >
            </div>
          </div>
        </div>
      </div>

      <TotalAll></TotalAll>
    </div>
  </div>
</template>
<script>
//详情
import Details from "../../../components/accidentManagement/Details";
import TotalAll from "./totalAll";
import Switchsite from "../../HomePageOverview/components/Switchsite";
import { chainIndex } from "../../../api/linkindex";
import Overviewitemcomponents from "./Overviewitemcomponents";
import { subscribe, unsubscribe } from "../../../mqtt/index";
//时间
import ThreeOrone from "./threeOrone";
import "../../../util/time";
export default {
  name: "overviewcomp",
  props: {
    data: Object,
  },
  data() {
    return {
      //数值
      numerical: "",
      //切换ABc
      isclick: 0,
      //负荷率
      loadRater: "",
      values: "",
      //电压等级
      breaker: "",
      transformerCapacity: "", //变压器容量
      voltageClasses1: "-", //进线断路器1
      voltageClasses2: "-", //进线断路器2
      // Ifseat:0,
      areaId: 0,
      transformerone: "",
      num: "",
      seat: [],
      clickBocks: 0,
      timeNow: 0, //时间
      homeitemall: 1,
      hour: "", //时间

      // ...mapState(["getindex"]),
      temperature: "", //湿度
      humidity: "", //温度
      id: 2,
      todaynum: "",
      event: [],
      gettitle: this.$store.state.homeitem.man,
      ck: 0,
      mqqttwo: 0,
      //负荷不平衡
      imbalance: "",
      state: {
        one: [
          {
            id: 1,
            class: "功率因数",
            data: "/PF", //对
            sign: "",
            backg: "优",
          },
          {
            id: 2,
            class: "有功功率",
            data: "/PA", //对
            sign: "kW",
            numtotal: 1000,
          },
          {
            id: 3,
            class: "谐波率",
            data: "/THD_U",
            sign: "%",
          },
        ],
      },
      Byq: [
        { id: 1, numitem: "A", data: "/Temperature_A" },
        { id: 2, numitem: "B", data: "/Temperature_B" },
        { id: 3, numitem: "C", data: "/Temperature_C" },
      ],
    };
  },
  beforeDestroy() {
    //console.log('销毁定时器')
    if (this.timer) {
      clearInterval(this.timer);
    }
  },

  watch: {
    todaynum(n, o) {
      this.todaynum = n;
      // console.log(n, o);
    },
    //4月7日注释
    list(n, o) {
      // console.log(n, o);
      this.list = n;
    },
    loadRater(n, o) {
      this.loadRater = n;
    },
    //13号注释
    // "$store.state.homeitem.mqqtitem"(n, o) {
    //   subscribe([n]);
    //   unsubscribe([o]);
    // },
    // "$store.getters.mqttVal"(n, o) {
    //   subscribe([n]);
    //   unsubscribe([o]);
    // },
    mqqttwo(n, o) {
      // console.log(n, o);
      subscribe([n]);
      unsubscribe([o]);
    },
    values(n, o) {
      // console.log(n, o);
      this.values = n;
      subscribe(n);
      unsubscribe(o);
    },
    num(n, o) {
      subscribe([n]);
      unsubscribe([o]);
      this.num = n;
      // console.log(this.num);
    },
  },

  mounted() {
    this.getWeatherInfo(); //气温
    this.compitem();
    this.stateTion();
    this.Fhl();
    this.homeitemclick();
    this.timer = setInterval(() => {
      // console.log('触发刷新');
    }, 60000);
  },
  updated() {
    this.Fhl();
  },

  components: {
    Switchsite,
    Details,
    Overviewitemcomponents,
    ThreeOrone,
    TotalAll,
  },

  methods: {
    Fhl() {
      this.areated = this.$store.state.homeitem.areaId
        ? this.$store.state.homeitem.areaId
        : 0;
      //进线断路器
      chainIndex.breaker(this.areated).then((res) => {
        // console.log(res.data.data);
       if(res.data.data){
            this.voltageClasses1 = res.data.data.result[0];
        this.voltageClasses2 =
          res.data.data.result[1] 
       }
        // console.log(res.data.data.result[1], "我是进线断路器");
      });
    },

    //天气
    getWeatherInfo() {
      // 天气信息
      fetch(
        "https://restapi.amap.com/v3/weather/weatherInfo?city=" +
          420114 +
          "&key=3ecd07184027ff3342dc5f24551c2ecc"
      )
        .then((response) => response.json())
        .then((json) => {
          // console.log(json, "我是温度");
          this.temperature = json.lives[0].temperature;
          this.humidity = json.lives[0].humidity;

          // console.log(this.temperature, this.humidity);
        })
        .catch((e) => {
          return e;
        });
    },

    stateTion() {
      if (this.$store.getters.mqttVal(this.mqqttwo + "/PF") <= 0.5) {
        this.state.one[0].backg = "差";
      } else if (this.$store.getters.mqttVal(this.mqqttwo + "/PF") <= 0.9) {
        this.state.one[0].backg = "良";
      } else {
        this.state.one[0].backg = "优";
      }
    },
    //某个样式移入移出
    homeitemclick() {
      //温度湿度渲染
      if (this.homeitemall > 0) {
        this.homeitemall = 0;
      } else {
        this.homeitemall = 1;
      }
    },

    compitem(val) {
      this.mqqttwo = val;
      //负荷不平衡公式
  
      let mean = (
        (this.$store.getters.mqttVal(this.mqqttwo + "/Ua") +
          this.$store.getters.mqttVal(this.mqqttwo + "/Ub") +
          this.$store.getters.mqttVal(this.mqqttwo + "/Uc")) /
        3
      ).toFixed(2);
      let max = Math.max(
        this.$store.getters.mqttVal(this.mqqttwo + "/Ua"),
        this.$store.getters.mqttVal(this.mqqttwo + "/Ub"),
        this.$store.getters.mqttVal(this.mqqttwo + "/Uc")
      );
      let min = Math.min(
        this.$store.getters.mqttVal(this.mqqttwo + "/Ua"),
        this.$store.getters.mqttVal(this.mqqttwo + "/Ub"),
        this.$store.getters.mqttVal(this.mqqttwo + "/Uc")
      );
      let load;
      if (((max - min) * 100) / mean == 0) {
        load = (((max - min) * 100) / mean).toFixed(2);
      } else {
        load = (((max - min) * 100) / mean).toFixed(2);
      }
      // console.log(mean, max, min, load, this.mqqttwo);
      this.$set(this.state.one, 3, {
        id: 4,
        class: "负荷不平衡",
        nodata: load == "NaN" ? "--" : load,
        sign: "%",
      });
    },
    handleValue(val) {
      this.mqqttwo = val;
      this.gettitle = val;

    },
     toAll() {
                this.areaId = this.$store.state.project.currentProject.projectId;

                this.$store.commit("setData", this.ck);
                this.$store.commit("Dthere", 1);
                chainIndex.site(this.areaId).then((res) => {
                    this.seat = res.data.data.areas[0].areaId;
                    this.$store.commit("webId",null);
                    this.$store.commit("projectid", "PROJECT_ID");
                });
            },
  },
};
</script>
<style lang="less" scoped>
#right {
  float: left;
  margin-left: 8rem;
  // background-color: gainsboro;
  #switchingroom {
    .w(528);
    .h(640);
    padding: 48rem 44rem 0 24rem;
    margin-bottom: 8rem;
    background-color: #ffffff;

    #oC {
      .w(120);
      white-space: nowrap;
      display: flex;
      justify-content: space-between;
      margin-bottom: 35rem;
      color: rgba(0, 43, 102, 0.6);
      font-size: 18rem;
      div {
        // font-size: 14rem;
        margin-left: 25rem;
      }
      p {
        margin-left: 0rem;
        // font-size: 14rem;
      }
    }
    .right-title {
      display: flex;
      justify-content: space-between;

      .el-button {
        .w(137);
        .h(32);
        font-size: 18rem;
        text-align: center;
        padding: 4rem 0;
      }
    }
    #siteswitch {
      .w(386);
      background-color: #ffffff;
      margin-bottom: 25rem;
      display: flex;
      #head {
        .w(64);
        .h(64);
        background-color: grey;
        img {
          width: 100%;
          height: 100%;
        }
      }
      #title-name {
        font-size: 32rem;
        font-weight: bold;
        color: #333333;
        margin-top: -8rem;
        margin-left: 10rem;
        margin-bottom: 0rem;
      }
      // #site {
      //   margin-top: 12rem;
      //   font-size: 16rem;
      //   margin-top: 0rem;
      //   margin-left: 16rem;
      // }
    }
  }

  #title {
    margin-bottom: 20rem;
    font-size: 18rem;
    // color: #333333;
  }
  #state {
    width: 100%;
    margin-bottom: 18rem;
    margin-top: 27rem;
    #state-one {
      display: flex;
      justify-content: space-between;
      margin-bottom: 30rem;
      margin-top: 20rem;
    }
    #state-two {
      display: flex;
      justify-content: space-between;
    }
  }
  #communication {
    font-size: 16rem;
    // color: #6666;
  }

  // #incidentrecord {
  //   .w(528);
  //   .h(320);
  //   position: relative;
  //   background-color: #ffffff;

  //   #today {
  //     margin-bottom: 19rem;
  //     padding: 23rem 64rem 0 24rem;
  //     color: #333333;
  //     font-size: 18rem;
  //   }
  //   #record {
  //     // padding: 0 46rem 0 0;
  //     display: flex;
  //     justify-content: space-between;
  //     padding: 10rem 64rem 10rem 24rem;
  //     // color: #FD4238;
  //     .backColor {
  //       color: black;
  //       font-size: 36rem;
  //     }
  //     .redColor {
  //       color: red;
  //       font-size: 36rem;
  //     }
  //     .pack {
  //       font-size: 16rem;
  //       color: #999999;
  //       margin: 10rem 0 0 0;
  //       cursor: pointer;
  //     }
  //     .pack:hover {
  //       color: #0d94ff;
  //     }
  //   }

  //   .kong {
  //     .h(1);
  //     .w(528);
  //     background: #000000;
  //     opacity: 0.06;
  //     margin-top: 19rem;
  //     margin-bottom: 15rem;
  //   }
  //   .timer {
  //     padding: 0 32rem 0 25rem;
  //     .totaynone {
  //       font-size: 18rem;
  //       font-weight: 400;
  //       color: #333333;
  //     }
  //     .headline {
  //       display: flex;
  //       justify-content: space-between;
  //       .timer-title {
  //         font-size: 18rem;
  //         color: #333333;
  //         margin-bottom: 10rem;
  //       }
  //       .timer-time {
  //         font-size: 16rem;
  //         color: #999999;
  //       }
  //     }
  //     #article {
  //       display: flex;
  //       justify-content: space-between;
  //       padding-right: 23rem;
  //       margin-top: 20rem;
  //       #description {
  //         font-size: 16rem;
  //         color: #999999;
  //         overflow: hidden;
  //         text-overflow: ellipsis;
  //       }
  //       #particulars {
  //         font-size: 16rem;
  //         color: #0d94ff;
  //       }
  //     }
  //   }
  // }

  #temperature-all {
    display: flex;
    width: 100%;
    justify-content: space-between;
    // background: red;
  }
  .temperature1,
  .temperature2 {
    width: 183rem;
    font-size: 18px;
    padding-top: 10rem;
    margin-right: 10rem;
    color: #aaa4a4;
    background: rgba(0, 43, 102, 0.04);
    // margin-top: 20rem;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .temperature-item1,
    .temperature-item2 {
      padding-top: 15px;
      padding-bottom: 10px;
      text-align: center;
      display: grid;
      justify-content: space-around; //  margin: auto;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .clay {
        display: flex;
        line-height: 30rem;
        font-size: 18px;
        // width: 80rem;

        // text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        h5 {
          white-space: nowrap;
          margin-top: 1rem;
          display: flex;
          text-align: left;
        }
        p {
          margin-left: 4rem;
          font-size: 14rem;
          line-height: 30rem;
        }
      }
    }
  }
  .temperature3 {
    width: 183rem;
    font-size: 19rem;
    padding-top: 10rem;
    color: #aaa4a4;
    background: rgba(0, 43, 102, 0.04);
    text-align: center;
    display: grid;

    .temperature-item3 {
      color: #333333;
      .clay {
        font-size: 24px;
        white-space: nowrap;
        display: flex;
        justify-content: center;
        align-items: center;
        p {
          margin-left: 2rem;
          margin-top: 4rem;
          font-size: 14rem;
          line-height: 30rem;
        }
      }
    }
  }
}
#list {
  display: flex;
  justify-content: space-between;
  padding-top: 23rem;
}
.record-item {
  font-size: 18px;
  font-weight: 400;
  color: #666666;
}
#electricquantity {
  .w(460);
  padding-bottom: 38rem;
  border-bottom: 1rem solid rgba(0, 0, 0, 0.15);
  display: flex;

  .record-op {
    margin-left: 26rem;
    font-size: 18px;
  display: flex;
  align-items: center;

    span {
      font-size: 18rem;
      // margin-top: -5px !important;
  margin-left: 5px;
  margin-right: 5px;
  }
  }
}
.record-st {
  margin-top: 12rem;
  font-size: 18px;
  text-align: center;
  span {
    font-size: 10rem;
  }
}
.clickfalls {
  display: flex;
  // margin-top: 20rem;
}
#nbsp {
  margin-left: 10rem;
  font-size: 10rem;
}
.kong {
  width: 20rem;
}
</style>